import { render, staticRenderFns } from "./PhoneLink.vue?vue&type=template&id=3377f146&scoped=true&"
import script from "./PhoneLink.vue?vue&type=script&lang=js&"
export * from "./PhoneLink.vue?vue&type=script&lang=js&"
import style0 from "./PhoneLink.vue?vue&type=style&index=0&id=3377f146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3377f146",
  null
  
)

export default component.exports